/**
 * `one` when `count` is exactly 1, otherwise `many`. Both forms are passed in so verbs can agree
 * too ("1 store is" / "2 stores are"), which a noun-only pluralizer cannot do.
 */
export const plural = (count: number, one: string, many: string): string =>
  count === 1 ? one : many;
